module.exports = __webpack_public_path__ + "img/service-part11-3.0bb8ef3d.png";